<template>
    <div class="about-takeover" aria-hidden="true">
        <img
            v-for="img in images"
            class="popup"
            :style="{ left: `${img.x}%`, top: `${img.y}%` }"
            :src="img.src"
        />
    </div>
</template>

<script>
import _random from 'lodash/random'

const IMAGE_COUNT = 13

export default {
    props: {
        asset: String
    },
    data() {
        return {
            images: []
        }
    },
    created() {
        setTimeout(this.addElement, 4500)
    },
    computed: {
        base() {
            const split = String(this.asset).split('/')
            split.pop()
            return split.join('/')
        }
    },
    methods: {
        addElement() {
            // stop after a few images
            // if (this.images.length >= 30) return

            this.images.push({
                src: `${this.base}/pop-${_random(1, IMAGE_COUNT)}.png?v=2`,
                x: _random(-5, 95),
                y: _random(-5, 95)
            })
            setTimeout(this.addElement, _random(3000, 4500))
        }
    }
}
</script>

<style lang="scss">
@import 'src/scss/mixins';

.about-takeover {
    pointer-events: none;
    overflow: hidden;
    position: fixed;
    z-index: 100;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;

    .popup {
        position: absolute;
        transform: scale(0.6);

        @include bp(s) {
            width: 50px;
        }
    }
}
</style>
